export const SORT_METHOD = {
  dateAsc: "Date: Oldest",
  dateDesc: "Date: Newest",
  titleAsc: "Product: A to Z",
  titleDesc: "Product: Z to A",
};
